<app-main-layout>
  <section class="flex flex-col gap-3">
    <app-card>
      <app-card-header
        title="Verfügbare Check-Ins"
        subTitle="heute"
        [iconPath]="'assets/icons/scan.svg'"
        [showLoadingSpinner]="requestState() === RequestStateEnum.PENDING"
      />

      <section class="flex flex-col gap-2">
        @if (activities().length === 0) {
          <app-no-entries-placeholder text="Keine Check-Ins verfügbar" />
        }

        @for (activity of activities(); track activity.id) {
          <app-check-in-item [activity]="activity">
            <app-button
              [fullWidth]="true"
              [disabled]="activity.isCheckedIn"
              [text]="activity.isCheckedIn ? 'Bereits eingecheckt' : 'Check-In'"
              (clicked)="openModal(activity)"
            />
          </app-check-in-item>
        }
      </section>
    </app-card>
  </section>
</app-main-layout>
